import AIOutreachAgentsList from './AIOutreachAgentsList';
import AIOutreachAgentsItem from './AIOutreachAgentsItem';

export {
  AIOutreachAgentsList,
  AIOutreachAgentsItem,
};



// WEBPACK FOOTER //
// ./src/components/AIOutreachAgents/index.js